import axios from "axios"

const deviceMonitor = {
  state: () => ({
    loading: false,
    deviceMonitors: [],
    deviceMonitorIncidents: {},
    deviceMonitor: null,
    devicesMonitorHeartbeats: {},
    createdDeviceMonitor: {},
    error: null,
  }),

  getters: {
    getDeviceMonitorHeartbeats: (state) => (deviceId) => {
      if (deviceId in state.devicesMonitorHeartbeats) {
        // already loaded
        const heartbeats = state.devicesMonitorHeartbeats[deviceId]
        if (heartbeats) {
          return heartbeats.Heartbeats
        }
      }
        
      return []
    },
    getDeviceMonitorIncidents: (state) => (deviceId) => {
      if (deviceId in state.deviceMonitorIncidents) {
        // already loaded
        const incidents = state.deviceMonitorIncidents[deviceId]
        if (incidents) {
          return incidents
        }
      }
        
      return []
    }
  },

  mutations: {
    SET_DEVICE_MONITOR_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_DEVICE_MONITOR_ERROR: (state, error) => {
      state.error = error
    },
    SET_DEVICE_MONITORS: (state, deviceMonitors) => {
      state.deviceMonitors = deviceMonitors
    },
    SET_DEVICE_MONITOR_ALLOCATIONS: (state, deviceMonitorAllocations) => {
      state.deviceMonitorAllocations = deviceMonitorAllocations
    },
    SET_DEVICE_MONITOR_INCIDENTS: (state, payload) => {
      state.deviceMonitorIncidents[payload.deviceMonitorId] = payload.incidents
    },
    SET_DEVICE_MONITOR: (state, deviceMonitor) => {
      state.deviceMonitor = deviceMonitor
    },
    SET_DEVICE_MONITOR_HINTS: (state, deviceMonitorHints) => {
      state.deviceMonitorHints = deviceMonitorHints
    },
    SET_CREATED_DEVICE_MONITOR: (state, createdDeviceMonitor) => {
      state.createdDeviceMonitor = createdDeviceMonitor
    },
    SET_DEVICE_MONITOR_HEARTBEATS: (state, payload) => {
      state.devicesMonitorHeartbeats[payload.deviceMonitorId] = payload.heartbeats
    }
  },

  actions: {
    ListDeviceMonitors(context, query) {
      return axios
        .get(`/projects/${query.projectId}/device-monitors`)
        .then((response) => {
          context.commit("SET_DEVICE_MONITORS", response.data)
          context.commit("SET_DEVICE_MONITOR_LOADING", false)
        })
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    ListDeviceIncidents(context, query) {
      return axios
        .get(
          `/projects/${query.projectId}/device-monitors/${query.deviceMonitorId}/incidents?limit=${query.limit}`
        )
        .then((response) => {
          context.commit("SET_DEVICE_MONITOR_INCIDENTS", {
            deviceMonitorId: query.deviceMonitorId,
            incidents: response.data,
          })
          context.commit("SET_DEVICE_MONITOR_LOADING", false)
        })
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    ListDeviceHeartbeats(context, query) {
      context.commit("SET_DEVICE_MONITOR_LOADING", true)

      if (!query.since) {
        query.since = '1h'
      }
      
      return axios
        .get(
          `/projects/${query.projectId}/device-monitors/${query.deviceMonitorId}/heartbeats?since=${query.since}`
        )
        .then((response) => {
          context.commit("SET_DEVICE_MONITOR_HEARTBEATS", {
            deviceMonitorId: query.deviceMonitorId,
            heartbeats: response.data
          })
          context.commit("SET_DEVICE_MONITOR_LOADING", false)
        })
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    GetDeviceMonitor(context, query) {
      return axios
        .get(
          `/projects/${query.projectId}/device-monitors/${query.deviceMonitorId}`
        )
        .then((response) => {
          context.commit("SET_DEVICE_MONITOR", response.data)
          context.commit("SET_DEVICE_MONITOR_LOADING", false)
        })
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    CreateDeviceMonitor(context, deviceMonitor) {
      context.commit("SET_DEVICE_MONITOR_ERROR", null)
      return axios
        .post(
          `/projects/${deviceMonitor.projectId}/device-monitors`,
          deviceMonitor
        )
        .then((response) => {
          context.commit("SET_CREATED_DEVICE_MONITOR", response.data)
        })
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    DeleteDeviceMonitor(context, deviceMonitor) {
      context.commit("SET_DEVICE_MONITOR_ERROR", null)
      return axios
        .delete(
          `/projects/${deviceMonitor.projectId}/device-monitors/${deviceMonitor.id}`
        )
        .then(() => {})
        .catch((error) =>
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        )
    },
    UpdateDeviceMonitor(context, deviceMonitor) {
      context.commit("SET_DEVICE_MONITOR_ERROR", null)
      return axios
        .patch(
          `/projects/${deviceMonitor.projectId}/device-monitors/${deviceMonitor.id}`,
          deviceMonitor
        )
        .then(() => {})
        .catch((error) => {
          context.commit(
            "SET_DEVICE_MONITOR_ERROR",
            error.response.data.error.message
          )
        })
    },
  },
}

export default deviceMonitor
